import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";

export default function MiniMetric({ title, val, prog, col }) {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.8 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight="700"
          sx={{ fontSize: "0.65rem" }}
        >
          {title}
        </Typography>
        <Typography
          variant="caption"
          fontWeight="800"
          fontFamily="monospace"
          color={col === "secondary" ? "text.primary" : `${col}.main`}
        >
          {val}
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={prog}
        color={col}
        sx={{
          height: 5,
          borderRadius: 1,
          bgcolor: "rgba(234,240,248,0.03)",
          "& .MuiLinearProgress-bar": { borderRadius: 1 },
        }}
      />
    </Box>
  );
}
